function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { PadMarg, Display } from './../../enhancers';
import css from './Spacer.sass';

function BaseSpacer(props) {
  var inline = props.inline,
      children = props.children,
      className = props.className;
  var classNames = cx(css.root, inline && css.inline, className);
  return React.createElement("div", {
    className: classNames
  }, children);
}

BaseSpacer.displayName = 'Spacer';

var DispalySpacer = function DispalySpacer(props) {
  return React.createElement(Display, _extends({
    InputComponent: BaseSpacer
  }, props));
};

var Spacer = function Spacer(props) {
  return React.createElement(PadMarg, _extends({
    InputComponent: DispalySpacer
  }, props, {
    propsMap: {
      top: 'padding-top',
      bottom: 'padding-bottom',
      left: 'padding-left',
      right: 'padding-right',
      margin: 'margin',
      padding: 'padding'
    }
  }));
};

BaseSpacer.propTypes = {
  /**
   * Custom class name
   */
  className: PropTypes.string,

  /**
   * Primary content
   */
  children: PropTypes.node,

  /**
   * Inline or block spacing
   */
  inline: PropTypes.bool
};
export { Spacer };